import { render, staticRenderFns } from "./AdditionalWork.vue?vue&type=template&id=67b5d836"
import script from "./AdditionalWork.vue?vue&type=script&lang=js"
export * from "./AdditionalWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports